module.exports = __webpack_public_path__ + "static/img/imgAdv.fd42f19c.png";